import { TbMessage2Check, TbMessage2Share, TbMessageX } from "react-icons/tb";

export function formatWallTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";

  return d.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
}

export function formatDateDividerLabel(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";

  return d.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

export function mergeByKey(prev, next) {
  const map = new Map();

  for (const m of prev) {
    const k = m.sk || `${m.wa_message_id}|${m.timestamp}`;
    map.set(k, m);
  }

  for (const m of next) {
    const k = m.sk || `${m.wa_message_id}|${m.timestamp}`;
    map.set(k, m);
  }

  return hydrateConversationMessages(
    [...map.values()].sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))
  );
}

export function chatHeaderTitle(phone, contacts) {
  if (!phone) return "Business Messenger";
  const c = contacts.find((x) => String(x.phone) === String(phone));
  return c?.nameOnly || "Unknown";
}

export function normalizeSocketMessage(msg) {
  const msgPhone = String(msg.ContactNumber || msg.contact_number || "");
  const rawContext = msg.Context || msg.context || null;

  return {
    contact_number: msgPhone,
    text: msg.Text || msg.text || "",
    timestamp: msg.Timestamp || msg.timestamp || new Date().toISOString(),
    direction: msg.Direction || msg.direction || "inbound",
    status: msg.Status || msg.status || "SENT",
    error: msg.Error || msg.error || null,
    wa_message_id:
      msg.WAMessageId || msg.wa_message_id || `temp-${Date.now()}`,
    sk: msg.SK || msg.sk || `MSG#${Date.now()}`,
    entity_type: msg.EntityType || msg.entity_type || "message",
    template: msg.Template || msg.template || null,
    reactions: msg.Reactions || msg.reactions || [],
    media: msg.Media || msg.media || [],
    contact_name: msg.ContactName || msg.contact_name || "",
    has_media: !!(msg.HasMedia || msg.has_media || (msg.Media && msg.Media.length) || (msg.media && msg.media.length)),
    context: rawContext ? {
      ...rawContext,
      message_id: rawContext.WAMessageId || rawContext.message_id || "",
      text: rawContext.Text || rawContext.text || ""
    } : null,
  };
}

export function hydrateConversationMessages(items) {
  return (items || [])
    .filter(
      (item) => String(item?.EntityType || item?.entity_type || "").toLowerCase() !== "reaction"
    )
    .map(normalizeSocketMessage);
}

export function StatusIcon({ status }) {
  const s = String(status || "SENT").toUpperCase();
  const baseStyle = { display: "flex", alignItems: "center" };

  if (s === "READ") {
    return (
      <span style={{ ...baseStyle, color: "#34B7F1" }}>
        <TbMessage2Check size={16} />
      </span>
    );
  }

  if (s === "DELIVERED") {
    return (
      <span style={{ ...baseStyle, color: "#667781" }}>
        <TbMessage2Check size={16} />
      </span>
    );
  }

  if (s === "FAILED") {
    return (
      <span style={{ ...baseStyle, color: "#d32f2f" }}>
        <TbMessageX size={16} />
      </span>
    );
  }

  if (s === "DELETED") {
    return (
      <span style={{ ...baseStyle, color: "#999", fontStyle: "italic", fontSize: "10px" }}>
        Deleted
      </span>
    );
  }

  return (
    <span style={{ ...baseStyle, color: "#667781" }}>
      <TbMessage2Share size={16} />
    </span>
  );
}
